import { defineNuxtPlugin, useRuntimeConfig } from "#app";
import { container, type DependencyContainer } from "tsyringe";
import { register, DITokens } from "@/di";
import type { Pinia } from "pinia";

export default defineNuxtPlugin<{ container: DependencyContainer }>(
  async (app) => {
    const pinia = app.$pinia as Pinia;
    const {
      public: { GMO_TOKEN_API_KEY, TCG_PLATFORM_ES_API_KEY, TCG_PLATFORM_ES_ENDPOINT, productTypeIds },
    } = useRuntimeConfig();
    const _container = container.createChildContainer();
    const __container = register(_container, { pinia, GMO_TOKEN_API_KEY, TCG_PLATFORM_ES_API_KEY, TCG_PLATFORM_ES_ENDPOINT, productTypeIds });

    // カートの復元処理
    if (process.client) {
      __container.resolve(DITokens.CartStore).restoreCart()
    }

    return {
      provide: {
        container: __container,
      },
    } as any;
  }
);
